export const SET_GROUP_METADATA = 'lv3/SET_GROUP_METADATA';
export const SET_GROUP_METADATA_IS_LOADING = 'lv3/SET_GROUP_METADATA_IS_LOADING';
